// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"src-modules-dashboard-components-FeatureRequestCard---wrapper---2XYg0","left":"src-modules-dashboard-components-FeatureRequestCard---left---1AoAL"};